export default __webpack_public_path__ + "static/media/padel-gold-logo.791771eb.png";